import config from '../../config/config';
import { map, get } from 'lodash';

export const CAPTURE_FAILURE = 'CAPTURE/CAPTURE_FAILURE';
export const CAPTURE_LOAD = 'CAPTURE/CAPTURE_LOAD';
export const CAPTURE_SUCCESS = 'CAPTURE/CAPTURE_SUCCESS';

export const CAPTURE_BULK_FAILURE = 'CAPTURE/CAPTURE_BULK_FAILURE';
export const CAPTURE_BULK_LOAD = 'CAPTURE/CAPTURE_BULK_LOAD';
export const CAPTURE_BULK_SUCCESS = 'CAPTURE/CAPTURE_BULK_SUCCESS';

export function captureTransaction(transaction, amountToCapture) {
    if (!amountToCapture) {
        amountToCapture = get(transaction, 'foreignProcessingCurrency.amount') || get(transaction, 'amount');
    }

    return {
        failureActionTypeOrCreator: createCaptureTransactionFailureActionCreator(transaction.id),
        fetchParams: {
            body: {
                id: transaction.id,
                amountToCapture: amountToCapture
            },
            method: 'POST',
            shouldAllowConcurrentFetches: true,
            url: `${config.transactionsApiUrl}/capture`
        },
        loadActionTypeOrCreator: createCaptureTransactionLoadActionCreator(transaction.id),
        successActionTypeOrCreator: createCaptureTransactionSuccessActionCreator(transaction.id, amountToCapture)
    };
}

export function createCaptureTransactionLoadActionCreator(id) {
    return () => ({
        id,
        type: CAPTURE_LOAD
    });
}

export function createCaptureTransactionFailureActionCreator(id) {
    return (error) => ({
        error,
        id,
        type: CAPTURE_FAILURE
    });
}

export function createCaptureTransactionSuccessActionCreator(id, amountCaptured) {
    return () => ({
        amountCaptured,
        id,
        type: CAPTURE_SUCCESS
    });
}

export function bulkCaptureTransactions(transactions) {
    const transactionIds = map(transactions, 'id');

    return {
        failureActionTypeOrCreator: createBulkCaptureTransactionFailureActionCreator,
        fetchParams: {
            body: { transactionIds },
            method: 'POST',
            url: `${config.transactionsApiUrl}/capture/bulk`
        },
        loadActionTypeOrCreator: CAPTURE_BULK_LOAD,
        successActionTypeOrCreator: createBulkCaptureTransactionSuccessActionCreator
    };
}

export function createBulkCaptureTransactionFailureActionCreator(error) {
    return {
        error,
        type: CAPTURE_BULK_FAILURE
    };
}

export function createBulkCaptureTransactionSuccessActionCreator() {
    return {
        type: CAPTURE_BULK_SUCCESS
    };
}
